var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tour-container"},_vm._l((_vm.tooltips),function(tooltip,tooltipIndex){return _c('step',{key:tooltipIndex,attrs:{"id":_vm.tourKey + '-tooltip-' + tooltipIndex,"tooltip":tooltip,"tourKey":_vm.tourKey},on:{"acknowledge":_vm.acknowledgeTooltip}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }